import { render, staticRenderFns } from "./MapaEleccionesSegunda.vue?vue&type=template&id=fa54e43a&"
import script from "./MapaEleccionesSegunda.vue?vue&type=script&lang=js&"
export * from "./MapaEleccionesSegunda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports